import React, { useState, useEffect, useRef } from "react";
import { observer } from "mobx-react";
import { IconButton } from "@material-ui/core";

import { useStore } from "../../store";
import { TranslationStr } from "../../utils/Translation";
import { Icon, HeaderBackButton } from "../../components";
import { SearchLabel, SearchInput, SearchForm } from "./style";
import { useHistory } from "react-router-dom";
import { firebaseEvent } from "../../utils/firebaseEvent";
import { setSearchList, setSelectType } from "../../utils/storage";
import { isAndroid } from "react-device-detect";

const SearchHeader = () => {
  const {
    appStore: {
      appState: { languageCode },
    },
    appStore: { apiHeaderState },
    searchStore: { onInitHashtagList, onGetHashTagList, onUpdateCurrentSearch },
  } = useStore();

  const inputRef = useRef<HTMLInputElement>(null);
  const [searchValue, setSearchValue] = useState("");

  // input focus
  useEffect(() => {
    inputRef.current?.focus();
    // eslint-disable-next-line
  }, [inputRef]);

  useEffect(() => {
    if (!searchValue) {
      onInitHashtagList();
      return;
    }

    const type = searchValue[0] === "#" ? "hashtag" : "title";
    onGetHashTagList(apiHeaderState, type, searchValue);
  }, [searchValue, apiHeaderState, onInitHashtagList, onGetHashTagList]);

  const RemoveSearchButton = () => {
    const onClick = () => {
      setSearchValue("");
      // ios 키보드 issue kmwd-357
      if (!isAndroid) setTimeout(onBlur);
    };

    const visibility = searchValue ? "visible" : "hidden";
    return (
      <IconButton
        style={{ visibility }}
        size="small"
        color="secondary"
        onClick={onClick}
      >
        <Icon name="inputDelete" size={24} />
      </IconButton>
    );
  };

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value;
    // android input maxLength 옵션 적용되지 않아 조건문으로 제어함
    if (value.length <= 30) {
      setSearchValue(value);
    } else {
      // 붙여넣기 이용시 30자 제어
      setSearchValue(value.substring(0, 30));
    }
  };

  //스크롤 시 네이티브 키보드 ui 제거를 위한 input blur
  useEffect(() => {
    document.addEventListener("scroll", onBlur);
    return () => {
      document.removeEventListener("scroll", onBlur);
    };
  }, []);

  const onBlur = () => {
    inputRef.current?.blur();
  };

  const history = useHistory();

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimSearchValue = searchValue.trim();
    if (trimSearchValue === "") {
      return false;
    } else {
      setSearchList(trimSearchValue);

      //Firebase Event
      onUpdateCurrentSearch({
        inputValue: trimSearchValue,
        searchValue: trimSearchValue,
      });
      setSelectType("search");
      const jsonParams = {
        P1: trimSearchValue,
        P2: trimSearchValue,
      };
      firebaseEvent("search_keyword", jsonParams);

      // 특수문자 '%' 의 경우 encode를 못하는 issue 가 발행히여 아래와 같이 'codePercent' 로 대치
      const encodeTag = trimSearchValue.includes("%")
        ? encodeURIComponent(trimSearchValue.replace(/%/gi, "percent2e5"))
        : encodeURIComponent(trimSearchValue);
      return history.push(`/search/${encodeTag}`);
    }
    // inputRef.current?.blur();
  };

  const placeholder = TranslationStr({
    locoKey: "feed_search_guide",
    languageCode,
  });

  return (
    <React.Fragment>
      <HeaderBackButton />
      <SearchForm action="" onSubmit={onSubmit}>
        <SearchLabel htmlFor="search">
          <SearchInput
            id="search"
            type="search"
            name="search"
            ref={inputRef}
            value={searchValue}
            onChange={onChange}
            placeholder={placeholder}
          />
          <RemoveSearchButton />
        </SearchLabel>
      </SearchForm>
    </React.Fragment>
  );
};

export default observer(SearchHeader);
